import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const LoginForm = ({ onToggleMode }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [errors, setErrors] = useState({
    email: '',
    password: '',
    general: ''
  });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Очищаем ошибку при вводе
    if (errors[name] || errors.general) {
      setErrors({
        ...errors,
        [name]: '',
        general: ''
      });
    }
  };

  const extractFieldErrors = (errorData) => {
    const fieldErrors = { email: '', password: '', general: '' };
    
    if (errorData.detail) {
      if (Array.isArray(errorData.detail)) {
        // Обработка массива ошибок от Pydantic
        errorData.detail.forEach(error => {
          if (error.loc && error.loc[1]) {
            const fieldName = error.loc[1];
            if (fieldName in fieldErrors) {
              fieldErrors[fieldName] = error.msg;
            }
          } else {
            fieldErrors.general = error.msg;
          }
        });
      } else if (typeof errorData.detail === 'string') {
        // Обработка строковой ошибки
        fieldErrors.general = errorData.detail;
      }
    }
    
    return fieldErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation(); // Добавьте эту строку!
    
    // Сбрасываем ошибки
    setErrors({ email: '', password: '', general: '' });
    
    // Базовая валидация на клиенте
    if (!formData.email || !formData.password) {
      setErrors({
        ...errors,
        general: 'Пожалуйста, заполните все поля'
      });
      return;
    }

    setLoading(true);

    try {
      const result = await login(formData.email, formData.password);
      
      if (!result.success) {
        // Если есть специфичные ошибки полей
        if (result.fieldErrors) {
          setErrors(result.fieldErrors);
        } else {
          setErrors({
            ...errors,
            general: result.error || 'Произошла ошибка при авторизации'
          });
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      
      if (error.response?.status === 422) {
        // Обработка ошибок валидации от сервера
        const fieldErrors = extractFieldErrors(error.response.data);
        setErrors(fieldErrors);
      } else {
        setErrors({
          ...errors,
          general: 'Ошибка соединения с сервером'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} noValidate> {/* Добавьте noValidate */}
      {errors.general && (
        <Alert variant="danger" className="mb-3">
          {errors.general}
        </Alert>
      )}
      
      <Form.Group className="mb-3">
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          name="email"
          placeholder="Введите ваш email"
          value={formData.email}
          onChange={handleChange}
          required
          size="lg"
          isInvalid={!!errors.email}
        />
        <Form.Control.Feedback type="invalid">
          {errors.email}
        </Form.Control.Feedback>
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Пароль</Form.Label>
        <Form.Control
          type="password"
          name="password"
          placeholder="Введите ваш пароль"
          value={formData.password}
          onChange={handleChange}
          required
          size="lg"
          isInvalid={!!errors.password}
        />
        <Form.Control.Feedback type="invalid">
          {errors.password}
        </Form.Control.Feedback>
      </Form.Group>
      
      <Button 
        type="submit"
        variant="primary"
        size="lg"
        className="w-100"
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Авторизация...
          </>
        ) : (
          'Войти'
        )}
      </Button>
      
      <div className="text-center mt-3">
        <span className="text-muted">Нет аккаунта? </span>
        <Button 
          variant="link" 
          onClick={onToggleMode}
          className="p-0 text-decoration-none"
        >
          Регистрация
        </Button>
      </div>
    </Form>
  );
};

export default LoginForm;